import { useState } from "react";
import { toast } from "sonner";
import { api, formatApiErrorDetail } from "@/lib/api";

const d = (i) => ({ transitionDelay: `${(i * 0.07).toFixed(2)}s` });

const TYPES = [
  "Sponsored content",
  "Brand ambassadorship",
  "UGC / content creation",
  "Gifting / product seeding",
  "Other",
];

const EMPTY = { name: "", email: "", brand: "", inquiry_type: "", message: "" };

export default function ConnectPanel() {
  const [form, setForm] = useState(EMPTY);
  const [loading, setLoading] = useState(false);

  const update = (field) => (e) => setForm((f) => ({ ...f, [field]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    if (!form.name || !form.email || !form.message) {
      toast.error("Please add your name, email and a short message.");
      return;
    }
    setLoading(true);
    try {
      const { data } = await api.post("/contact", form);
      toast.success(data.message || "Thank you — I'll be in touch soon.");
      setForm(EMPTY);
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || "Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className="panel sec-connect" id="connect" data-testid="panel-connect">
      <div className="connect-grid">
        <div className="connect-intro">
          <div className="sec-eyebrow reveal" style={d(0)}>Work With Me</div>
          <h2 className="sec-h reveal" style={d(1)}>
            Partnerships rooted in <em>authenticity.</em>
          </h2>
          <p className="sec-sub reveal" style={{ ...d(2), margin: "0 0 22px" }}>
            I love partnering with brands that align with intentional living, motherhood, and a
            beautifully run home. From sponsored stories to long-term ambassadorships, let's create
            something genuine together.
          </p>
          <ul className="connect-list reveal" style={d(3)}>
            <li>Sponsored content & storytelling</li>
            <li>Brand ambassadorships</li>
            <li>UGC & content creation</li>
            <li>Affiliate & gifting collaborations</li>
          </ul>
        </div>

        <form className="connect-form reveal" style={d(2)} data-testid="contact-form" onSubmit={submit}>
          <div className="cf-row">
            <input data-testid="contact-name-input" placeholder="Your name *" value={form.name} onChange={update("name")} />
            <input data-testid="contact-email-input" type="email" placeholder="Email *" value={form.email} onChange={update("email")} />
          </div>
          <input data-testid="contact-brand-input" placeholder="Brand / company" value={form.brand} onChange={update("brand")} />
          <select data-testid="contact-type-select" value={form.inquiry_type} onChange={update("inquiry_type")}>
            <option value="">Type of inquiry</option>
            {TYPES.map((t) => (
              <option key={t} value={t}>{t}</option>
            ))}
          </select>
          <textarea data-testid="contact-message-input" placeholder="Tell me about your project *" value={form.message} onChange={update("message")} />
          <button type="submit" className="btn-primary" disabled={loading} data-testid="contact-submit-button">
            {loading ? "Sending…" : "Send Inquiry →"}
          </button>
        </form>
      </div>
    </section>
  );
}
